import React from "react";
import PropTypes from "prop-types";
import { useSelect } from "downshift";
import classNames from "classnames";
import { ArrowIcon, CaretIcon } from "../icons";

const DropdownSelect = ({
  items,
  selectedItem,
  onChange,
  label,
  wrapperClass,
  theme,
  filterItems,
  renderItem,
}) => {
  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items,
    selectedItem,
    onSelectedItemChange: onChange,
  });

  return (
    <div
      className={classNames(
        `m-dropdown-select m-dropdown-select--${theme} ${wrapperClass}`
      )}
      role="form"
    >
      <div className="a-hidden" {...getLabelProps()}>
        {label}
      </div>
      <button
        className="m-dropdown-select__wrapper"
        {...getToggleButtonProps()}
      >
        <span className="m-dropdown-select__selection">
          {selectedItem ? selectedItem.name : "Filter"}
        </span>
        <CaretIcon
          styleProps={{ transform: isOpen ? undefined : "rotate(180deg)" }}
        />
      </button>
      <ul
        className={classNames({
          "m-dropdown-select__listbox": true,
          "m-dropdown-select__listbox--is-open": isOpen,
        })}
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={classNames({
                "m-dropdown-select-item": true,
                "m-dropdown-select-item--is-active": highlightedIndex === index,
                "m-dropdown-select-item--is-selected": selectedItem === item,
              })}
              key={`${item}${index}`}
              {...getItemProps({ item, index })}
            >
              {renderItem(item)}
              <ArrowIcon className="m-dropdown-select-item__arrow-icon" />
            </li>
          ))}
      </ul>
    </div>
  );
};

DropdownSelect.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItem: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  theme: PropTypes.oneOf(["default", "subnav", "slideshow"]),
  filterItems: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
};

export default DropdownSelect;
